import React from "react";
import { PhoneNumberUtil } from "google-libphonenumber";

const phoneUtil = PhoneNumberUtil.getInstance();

interface IPhoneInput extends React.InputHTMLAttributes<HTMLInputElement> {
  clx?: string;
  defaultCountryCode: string;
  onPhoneNumberChange?: ( formattedNumber: string, isValid: boolean, errorMessage: string) => void;
}

const PhoneInput: React.FC<IPhoneInput> = ({ clx, defaultCountryCode, onPhoneNumberChange, ...rest }) => {

  const handleInputChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    try {
      const number = phoneUtil.parse(input, defaultCountryCode);
      const valid = phoneUtil.isValidNumber(number);
      onPhoneNumberChange?.(phoneUtil.parseAndKeepRawInput(input, defaultCountryCode).getNationalNumber()?.toString() || input, valid, valid ? "" : "Invalid phone number");
    } catch (error) {
      onPhoneNumberChange?.(input, false, "Invalid phone number");
    }
  };

  return <input type='tel' onChange={handleInputChange} {...rest} />;
};

export default PhoneInput;